module.exports = __webpack_public_path__ + "images/saaremaa/kihnu 1024.png";